module.exports = __webpack_public_path__ + "static/media/hero_img_homepage.ba8473dd.png";